import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {KlinikaxpPaymentRequiredReservation} from "../../models/klinikaxp-payment-required-reservation.model";
import {Subscription} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../providers/user.service";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {KlinikaxpPaymentRequiredReservationService} from "../../providers/klinikaxp-payment-required-reservation.service";
import {ModalController} from "@ionic/angular";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {mobilePhoneNumberValidator} from "../../utils/form-validators";

@Component({
  selector: 'app-change-link-contact-data',
  templateUrl: './change-link-contact-data.component.html',
  styleUrls: ['./change-link-contact-data.component.scss'],
})
export class ChangeLinkContactDataComponent implements OnInit, OnDestroy {

  @Input()
  klinikaxpPaymentRequiredReservation: KlinikaxpPaymentRequiredReservation;
  @Input() title: string;
  @Input() serverTime: string;
  @Input() smsEnabled: boolean;
  sendSMS: boolean;
  smsBalanceTooSmall: boolean = false;
  credentialNotProvided: boolean = false;
  smsServerBalanceCheckSub: Subscription;
  sendEmail: boolean = true;
  xpReservationGroup: FormGroup;
  isBusy: boolean;
  hasUnsavedChanges: boolean;
  isBusySub: Subscription;
  vetClinicSub: Subscription;
  klinikaxpPaymentResquredReservationServiceSub: Subscription;
  showForm: boolean = false;
  regex = new RegExp('^\\d+(\\.\\d{1,2})?$');

  private alertPresented: boolean;
  vetDoctorVetVisitTypeUUID: string;

  constructor(private  userService: UserService, private appStateService: AppStateService, private commonUtils: CommonUtils,
              private klinikaxpPaymentResquredReservationService: KlinikaxpPaymentRequiredReservationService, private modalController: ModalController,
              private formBuilder: FormBuilder, private vetClinicService: VetClinicService, @Inject(LOCALE_ID) private locale: string) {
  }

  ngOnDestroy(): void {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
    if (this.vetClinicSub) {
      this.vetClinicSub.unsubscribe();
    }
    if (this.klinikaxpPaymentResquredReservationServiceSub) {
      this.klinikaxpPaymentResquredReservationServiceSub.unsubscribe();
    }
    if (this.smsServerBalanceCheckSub) {
      this.smsServerBalanceCheckSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });

    if (this.smsEnabled) {
      this.smsServerBalanceCheckSub = this.vetClinicService.checkSmsServerBalance(this.klinikaxpPaymentRequiredReservation.vetcodeId).subscribe(r => {
        this.sendSMS = r;
        if (this.sendSMS !== true) {
          this.smsBalanceTooSmall = true;
        }
      }, error => {
        if (error && error.message) {
          if (error.message === 'CREDENTIAL_NOT_PROVIDED') {
            this.sendSMS = false;
            this.credentialNotProvided = true;
          }

          if (error.message === 'FUNDS_NOT_AVAILABLE') {
            this.sendSMS = false;
            this.smsBalanceTooSmall = true;
          }
        } else {
          this.sendSMS = false;
        }
      });
    }

    this.xpReservationGroup = this.formBuilder.group({
      userPhoneNumber: [this.klinikaxpPaymentRequiredReservation.userPhoneNumber, [Validators.required, mobilePhoneNumberValidator, this.noWhitespaceValidator]],
      email: [this.klinikaxpPaymentRequiredReservation.email, [Validators.required, Validators.email, this.noWhitespaceValidator]],
    });

  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {'whitespace': true};
  }

  onClose() {
    this.modalController.dismiss();
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }


  onEdit() {
    if (this.xpReservationGroup.valid) {
      this.appStateService.updateIsBusySubject(true);
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zmienić adres email i wysłać link ponownie?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          if (this.xpReservationGroup.contains('medicalProcedurePrice')) {
            this.xpReservationGroup.removeControl('medicalProcedurePrice');
          }
          let obj = this.commonUtils.formGroupValuesToObject<KlinikaxpPaymentRequiredReservation>(new KlinikaxpPaymentRequiredReservation(), this.xpReservationGroup);
          if (obj) {
            this.klinikaxpPaymentRequiredReservation.email = obj.email;
            this.klinikaxpPaymentRequiredReservation.sendEmail = this.sendEmail;
            this.klinikaxpPaymentRequiredReservation.userPhoneNumber = obj.userPhoneNumber;
            if (this.smsEnabled) {
              this.klinikaxpPaymentRequiredReservation.sendSMS = this.sendSMS;
            }
            this.klinikaxpPaymentResquredReservationServiceSub = this.klinikaxpPaymentResquredReservationService.updateContactDataAndSendLink(this.klinikaxpPaymentRequiredReservation).subscribe(e => {
              if (e) {
                this.appStateService.updateIsBusySubject(false);
                if (e.sendEmail && e.sendSMS) {
                  if (e.sendSMS && !e.smsId && e.emailId) {
                    this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane tylko na adres email klienta');
                  }
                  if (e.sendEmail && !e.emailId && e.smsId) {
                    this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane tylko przez SMS na wskazany numer klienta klienta');
                  }
                  if (e.emailId && e.smsId) {
                    this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane do klienta');
                  }

                } else {
                  if (e.emailId || e.smsId) {
                    this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane do klienta');
                  } else {
                    this.commonUtils.presentAlertToast('Nie można przesłać danych do płatności klientowi');
                  }
                }
                this.modalController.dismiss();
              } else {
                this.appStateService.updateIsBusySubject(false);
                this.commonUtils.presentAlertToast("Wystąpił bład podczas wysyłania danych do płatności");
              }
            }, error => {
              switch (error.message) {
                case 'VETCODE_DATE_TEST_FAILED':
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast('Sprawdź dane w klinice, pracownik nie jest dostępny w tych godzinach')
                  break;
                case 'DATE_TEST_FAILED':
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast('W danych godzinach istnieje już zarezerwowany termin')
                  break;
                case 'TERMS_OF_AGREEMENT_NOT_FOUND':
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast("Przepraszamy, wysyłanie linków nie jest możliwe bez wcześniejszego skonfigurowania regulaminu")
                  break;
                case 'VET_DOCTOR_NOT_FOUND':
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast("Ten termin nie ma przypisanego lekarza w Vetineo. Dodaj go do rezerwacji w Klinice Xp lub skontaktuj się z obsługa klienta - 456 456 114")
                  break;
                case 'MESSAGE_NOT_SEND':
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast("Nie wysłano wiadomości, przejdź do zakładki wysłane linki, wybierz termin, popraw dane kontaktowe i wyślij wiadomość");
                  this.modalController.dismiss();
                  break;
                default:
                  this.appStateService.updateIsBusySubject(false);
                  this.commonUtils.presentAlertToast("Wystąpił bład podczas wysyłania danych do przelewu");
                  break;
              }
            });
          }

        }, () => {
          this.appStateService.updateIsBusySubject(false);
        });
    }
  }

  isFormFieldInvalid(formGroup: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(formGroup, fieldName, validationType);
  }


  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, chcesz anulować?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          this.onClose();
        }, () => {
        });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno anulować wysyłanie informacji o płatności?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          this.onClose();
        }, () => {
        });
    }
  }


  handleAlert(alertString: string) {
    if (!this.alertPresented) {
      this.commonUtils.presentAlertToast(alertString);
      this.alertPresented = true;
      setTimeout(() => {
        this.alertPresented = false;
      }, 4000);
    }
  }
}
